/** CI defaults: copied to config.js by scripts/ensure-config.js when missing. */
let BASE_URL = ";"
//根据环境变量来判断使用的接口地址
switch (process.env.VUE_APP_TITLE) {
  case 'alpha':
    BASE_URL = "http://localhost:8087"
    break
  case 'niuku':
    BASE_URL = "http://47.107.79.132:8087"
    break
  case 'tuotu':
    // erp.wtl-fba.com 已启用 HTTPS + nginx 同源反代，走同源避免混合内容
    BASE_URL = ""
    break
  case 'tcgj':
    // BASE_URL = "http://erp.huoping.net:8088"
    BASE_URL=""
    break
  case 'alex':
    BASE_URL = "http://8.129.172.219:8089"
    break
  case 'tchk':
    BASE_URL = "http://erp.fbaj.com:8090"
    break
  case 'peng':
    BASE_URL = "http://119.23.232.152:8087"
    break
  case 'nk':
    BASE_URL = "http://124.156.188.241:8087"
    break
  case 'st':
    BASE_URL = "http://120.24.182.136:8087"
    break
  case 'zhengcang':
    BASE_URL = "http://47.107.42.82:8087"
    break
  case 'mi':
    BASE_URL = "http://119.91.109.161:8087"
    break
  case 'laomi':
    BASE_URL = "http://120.78.70.39:8087"
    break
  case 'juyi':
    BASE_URL = "http://47.100.218.86:8087"
    break 
  case 'RICHENG':
      BASE_URL = "http://47.106.184.35:8087"
    break 
  case 'laozhu':
      BASE_URL = "http://120.25.163.66:8087"
    break 
  case 'jiuzhou':
      BASE_URL = "http://47.112.115.130:8087"
    break 
  case 'astra':
      BASE_URL = "http://120.79.41.89:8087"
    break 
  case 'xmluz':
      BASE_URL = "http://120.25.76.243:8087"
    break 
  case 'linxin':
    BASE_URL = "http://112.74.48.86:8087"
  break
  case 'nuota':
    BASE_URL = "http://43.165.188.17:8087"
   break
   case 'jrfba':
    BASE_URL = "http://8.138.239.162:8087"
   break
   case  'jack':
    BASE_URL = "http://47.243.204.69:8087"
   break
   case 'nick':
    BASE_URL = "http://zfshipping.online:8087"
   break
  default:
    //默认使用的接口地址
    BASE_URL = "http://localhost:8087"
}

const managerApi = BASE_URL ? BASE_URL + "/manager/api/1.0/" : "/manager/api/1.0/";
const portalApi = BASE_URL ? BASE_URL + "/portal/api/1.0/" : "/portal/api/1.0/";
export default {
  managerApi,
  portalApi
};